import { render, staticRenderFns } from "./SorterArrow.vue?vue&type=template&id=3d262784&scoped=true&"
import script from "./SorterArrow.vue?vue&type=script&lang=js&"
export * from "./SorterArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d262784",
  null
  
)

export default component.exports